import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ReferenceDataCountryListApi } from './api/reference-data-countries.api';
import { ReferenceDataCountriesEffects } from './state/reference-data-countries.effects';
import { REFERENCE_DATA_COUNTRIES_FEATURE_KEY, reducer } from './state/reference-data-countries.reducer';

@NgModule({
    imports: [
        StoreModule.forFeature(REFERENCE_DATA_COUNTRIES_FEATURE_KEY, reducer),
        EffectsModule.forFeature([ReferenceDataCountriesEffects]),
    ],
    providers: [ReferenceDataCountryListApi],
})
export class ReferenceDataCountriesDataAccessModule {}
